import { DoqType } from '@ardoq/doq';
import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';

type EmptyStateProps = {
  hasActiveFilter: boolean;
  isPresentationMode: boolean;
  isWorkspaceEmpty: boolean;
};

const EmptyStateBase = ({
  hasActiveFilter,
  isPresentationMode,
  isWorkspaceEmpty,
}: EmptyStateProps) => {
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.CAPABILITY_MAP_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (hasActiveFilter) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.CAPABILITY_MAP_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  return null;
};

export const EmptyState = connect(EmptyStateBase, emptyView$);
